'use strict';
var allPopulationElements = document.querySelectorAll('.population');
var totalPopulationElement = document.querySelector('.total-population');
var averagePopulationElement = document.querySelector('.average-population');
var totalPopulation = 0;
allPopulationElements.forEach(function(population) {
    var populationNumber = parseInt(population.textContent.replaceAll(',', ''));
    if (!Number.isNaN(populationNumber)) totalPopulation += populationNumber;
});
totalPopulationElement.textContent = totalPopulation.toLocaleString('en-IN');
averagePopulationElement.textContent = Math.round(totalPopulation / allPopulationElements.length).toLocaleString('en-IN');

//# sourceMappingURL=js_get_data_DOM.f244f50c.js.map
